// Copyright (C) Unite Digital LLC - All Rights Reserved.
// Unauthorized copying of this file, via any medium is strictly prohibited.
// Proprietary and confidential.
// Developed by Unite Digital LLC.

import { FormGroup } from '@angular/forms';
import { ChangePasswordModalComponent } from '../modals/change-password-modal/change-password-modal.component';

// eslint-disable-next-line no-useless-escape
export const passwordPattern = /^(?=.{8,})(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*\W).*$/;
// eslint-disable-next-line no-useless-escape
export const usPhonePattern = /^(\([2-9][0-9]{2}\)){1}[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/im;

export const emailPattern = /^([a-zA-Z0-9._%-+()&*^$!~`\#{}\]\[/.,-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})$/;

//legalNamePattern ensures that the user can only enter letters,numbers, diacritics, and specified chars into the Legal Name field
// export const legalNamePattern = /^[\p{L}\p{N}\p{M}', -]+$/gm;
export const legalNamePattern = /^[\p{L}\p{N}\p{M}'.,\s-]+$/u;
// eslint-disable-next-line no-useless-escape
export const namePattern = /^[a-z ,.'-]+$/i;

export const maxFileSizeMb = 25;

export const maxFileNameLength = 100;

// phone directive only displays 10 digits, it does not remove any digits above 10
// so autofilling with country code (ie, 1-xxx-xxx-xxxx) will save a number with 11 digits & +1
// cognito requires +1 to store phone number - going directly to cognito when creating a deal
export function phoneExporter(phone?: string): string {
    if (phone == null) {
        return '';
    }

    let cleansed = phone.replace(/\D/g, '');
    cleansed = cleansed.startsWith('1') ? cleansed.substring(1) : cleansed.substring(0, 10);
    return `+1${cleansed}`;
}

export function faxExporter(fax: string): string {
    let cleansed = fax.replace(/\D/g, '');

    cleansed.startsWith('+1') ? (cleansed = cleansed.substring(2)) : (cleansed = cleansed.substring(0, 10));

    return cleansed;
}

export function phoneImporter(phone: string): string {
    const cleansed = phone.replace(/\-/g, '');

    return cleansed.length >= 12 ? cleansed.substring(2) : cleansed;
}

export function showFormErrors(fields: any): void {
    for (const f in fields) {
        fields[f]['touched'] = true;
    }
}

export function passwordMatch(form: FormGroup): null {
    // start assessing if password2 has a value
    if (form.get('password2').value !== '') {
        // add noMatch error to display if passwords match
        if (form.get('password').value !== form.get('password2').value) {
            form.controls.password2.setErrors({
                noMatch: true,
            });
        }

        // need to remove the noMatch error if the passwords match
        if (form.get('password').value === form.get('password2').value) {
            form.controls.password2.setErrors(null);
        }
    }

    return null;
}

export function currentPasswordErrorControlValidator(component: ChangePasswordModalComponent) {
    return () => (component.currentPasswordError ? { currentPasswordError: true } : null);
}

export function fileIsPdfOrJpg(file: any): boolean {
    return file.type === 'image/jpeg' || file.type.includes('pdf');
}

export function fileSizeIsUnderMaxLimit(file: any): boolean {
    const fileSizeInMegabytes = file.size / 1048576;
    return fileSizeInMegabytes < maxFileSizeMb;
}

export function fileNameLessThanCharactersLimit(file: any): boolean {
    return file.name.length <= maxFileNameLength;
}
